package fr.frux.feature.treedetail.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.HideImage
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_photo_failed_description
import fr.frux.feature.treedetail.resources.treedetail_photo_failed_tile_many
import fr.frux.feature.treedetail.resources.treedetail_photo_failed_tile_one
import org.jetbrains.compose.resources.stringResource

private val TILE_RADIUS = 20.dp

/**
 * Tuile « Pas envoyée » (#633) : prend la place de la tuile « Ajouter une photo » tant qu'une
 * photo de l'arbre n'est pas partie. Le renvoi se fait par l'encart sous la grille.
 */
@Composable
internal fun FailedPhotoTile(
    count: Int,
    modifier: Modifier = Modifier,
) {
    val error = MaterialTheme.colorScheme.error
    val description = stringResource(Res.string.treedetail_photo_failed_description)
    Column(
        modifier =
            modifier
                .clip(RoundedCornerShape(TILE_RADIUS))
                .background(MaterialTheme.colorScheme.errorContainer)
                .drawBehind {
                    val stroke = 1.5.dp.toPx()
                    drawRoundRect(
                        color = error,
                        topLeft = Offset(stroke / 2, stroke / 2),
                        size = Size(size.width - stroke, size.height - stroke),
                        cornerRadius = CornerRadius(TILE_RADIUS.toPx() - stroke / 2),
                        style =
                            Stroke(
                                width = stroke,
                                pathEffect = PathEffect.dashPathEffect(floatArrayOf(8f, 8f)),
                            ),
                    )
                }.semantics(mergeDescendants = true) { contentDescription = description }
                .padding(horizontal = 8.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterVertically),
    ) {
        Icon(
            imageVector = Icons.Outlined.HideImage,
            contentDescription = null,
            modifier = Modifier.size(30.dp),
            tint = MaterialTheme.colorScheme.onErrorContainer,
        )
        Text(
            text =
                if (count > 1) {
                    stringResource(Res.string.treedetail_photo_failed_tile_many, count)
                } else {
                    stringResource(Res.string.treedetail_photo_failed_tile_one)
                },
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onErrorContainer,
            textAlign = TextAlign.Center,
        )
    }
}
